var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"panel__tree min-vh-full",attrs:{"no-gutters":""}},[_c('PanelLeft'),_c('PanelRight')],1)}
var staticRenderFns = []

export { render, staticRenderFns }